import '../components/jobui/styles/globals.css'
import '../components/jobui/styles/input.css'

import { ModuleSelector } from '../components/jobui/ModuleSelector'

export const CreateJob = () => (
  <div className="jobui-globalContainer">
    <div className="jobui-createContainer">
      <div className="header !pr-[50px]">
        <h1 className="text-primary-900 font-medium text-[30px] pl-[10px]">
          What are we making ?
        </h1>
      </div>
      <div className="jobui-section">
        <ModuleSelector />
      </div>
    </div>
  </div>
)
